import { getGridSummaryCount, renderGridSummarySumHL } from 'components/global/utils';
import { SkuReportGridData } from '@pages/reporting-pages/deliveries-sku/types/SkuReportGridData';



interface GridSummaryProps<T> {
	data?: T[] | null,
}


const GridSummary = (props: GridSummaryProps<SkuReportGridData>) => {
	const { data } = props;

	return (
		<>
			<div className='app-grid-summary'>
			</div>

			<div className='app-grid-summary'>
			</div>

			<div className='app-grid-summary'>
			</div>

			<div className='app-grid-summary'>
				<p>{getGridSummaryCount(data)}</p>
			</div>

			<div className='app-grid-summary'>
				<p>{renderGridSummarySumHL(data, 'totalVolume')}</p>
			</div>

			<div className='app-grid-summary'>
				<p>{renderGridSummarySumHL(data, 'onTradeVolume')}</p>
			</div>

			<div className='app-grid-summary'>
				<p>{renderGridSummarySumHL(data, 'offTradeVolume')}</p>
			</div>
		</>
	)
}

export default GridSummary;